import { ModelSelection } from 'components/Product/ProductFeatures';
import {
  BB,
  BBLight95,
  BodyTextL,
  BodyTextM,
  GRAY10,
  GRAY50,
  GRAY90,
  H4,
  H4KR,
  SubtitleM,
} from 'global-styles';
import Image from 'next/image';
import React, { Fragment } from 'react';
import styled from 'styled-components';

interface Props {
  locale: string;
  aiModelSelection: ModelSelection;
}

const AiModelSelection = ({ locale, aiModelSelection }: Props) => {
  return (
    <AiModelSelectionContainer>
      {locale === 'en' ? (
        <H4>Choosing an artificial intelligence Model</H4>
      ) : (
        <H4KR>인공지능 모델 선택</H4KR>
      )}

      <BodyTextL className="select-desc">
        {aiModelSelection.briefText[locale]}
      </BodyTextL>

      <div className="model-box-wrapper">
        {aiModelSelection.modelItems.map((model, i: number) => (
          <Fragment key={model.modelName.en[0]}>
            <div className="model-box" key={model.modelDesc[locale]}>
              <div className="picto-img-wrapper">
                <div className="picto-img-inner-wrapper">
                  <Image
                    className="picto-img"
                    src={model.modelPictoImg}
                    layout="fill"
                    alt="About bluedot"
                    objectFit="cover"
                    quality={70}
                  />
                </div>
              </div>

              <div className="content-wrapper">
                <SubtitleM className={locale === 'en' ? 'm-name-c' : 'm-name'}>
                  {model.modelName[locale][0]}
                  <span className="m-name-t">{model.modelName[locale][1]}</span>
                </SubtitleM>
                <BodyTextM className="model-desc-text">
                  {model.modelDesc[locale]}
                </BodyTextM>
              </div>
            </div>
            <>{i === 0 && <div className="model-box-dv" />}</>
          </Fragment>
        ))}
      </div>
    </AiModelSelectionContainer>
  );
};

export default AiModelSelection;

const AiModelSelectionContainer = styled.div`
  padding: 146px 0 96px;
  .select-desc {
    color: ${GRAY50};
    margin: 8px 0 32px;
  }
  .model-desc-text {
    color: ${GRAY50};
  }
  .model-box-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 24px 20px;
  }
  .model-box {
    width: 100%;
    display: flex;
    align-items: center;
    position: relative;
  }
  .model-box-dv {
    margin: 0 24px;
    width: 1px;
    height: 88px;
    background: ${GRAY90};
  }
  .m-name,
  .m-name-c {
    white-space: wrap;
    display: flex;
    align-items: center;
    color: ${GRAY10};
  }
  .m-name-c {
    flex-direction: column;
    align-items: flex-start;
  }
  .m-name-t {
    font-size: 17px;
    margin-left: 8px;
    color: ${BB};
  }
  .m-name-c .m-name-t {
    margin-left: 0;
  }
  .picto-img-wrapper {
    flex-shrink: 0;
    margin-right: 20px;
    position: relative;
    width: 88px;
    height: 88px;
    background: ${BBLight95};
    border-radius: 50%;
    padding: 14px;
    align-self: flex-start;
  }
  .picto-img {
    width: 100%;
    height: 100%;
  }
  .picto-img-inner-wrapper {
    position: relative;
    width: 60px;
    height: 60px;
  }
  @media screen and (max-width: 904px) {
    padding: 146px 0 56px;
    .model-box-wrapper {
      flex-direction: column;
      padding: 20px 16px;
    }
    .model-box-dv {
      margin: 20px 0;
      width: 100%;
      height: 1px;
    }
    .picto-img-wrapper {
      width: 80px;
      height: 80px;
    }
    .picto-img-inner-wrapper {
      width: 55px;
      height: 55px;
    }
  }
  @media screen and (max-width: 599px) {
    padding: 146px 0 32px;
    .m-name,
    .m-name-c {
      font-size: 17px;
    }
  }
`;
